import { useEffect, useState } from "react"
import { Server } from "stellar-sdk"

import { HORIZON_URL, TOKENS } from "../utils/constants"

export function useStellarAccount(initialPublicKey) {
  const [publicKey, setPublicKey] = useState(initialPublicKey)
  const [account, setAccount] = useState(null)
  const [money, setMoney] = useState(0)
  const [energy, setEnergy] = useState()
  const [berries, setBerries] = useState()
  const [meat, setMeat] = useState()
  const [food, setFood] = useState()
  const [stone, setStone] = useState()
  const [wood, setWood] = useState()
  const [iron, setIron] = useState()
  const [steel, setSteel] = useState()
  const [coal, setCoal] = useState()
  const [axes, setAxes] = useState()
  const [pickaxes, setPickaxes] = useState()
  const [spears, setSpears] = useState()
  const [hammers, setHammers] = useState()
  const [server] = useState(new Server(HORIZON_URL))

  useEffect(() => {
    if (publicKey) {
      server
        .loadAccount(publicKey)
        .then(account => setAccount(account))
        .catch(console.log)
    }
  }, [publicKey, server])

  useEffect(() => {
    if (account) {
      setEnergy(getBalance(account, TOKENS.ENERGY.CODE, TOKENS.ENERGY.ISSUER))
      setMoney(getBalance(account, TOKENS.MONEY.CODE, TOKENS.MONEY.ISSUER))
      setFood(getBalance(account, TOKENS.FOOD.CODE, TOKENS.FOOD.ISSUER))
      setAxes(getBalance(account, TOKENS.AXE.CODE, TOKENS.AXE.ISSUER))
      setBerries(getBalance(account, TOKENS.BERRY.CODE, TOKENS.BERRY.ISSUER))
      setMeat(getBalance(account, TOKENS.MEAT.CODE, TOKENS.MEAT.ISSUER))
      setWood(getBalance(account, TOKENS.WOOD.CODE, TOKENS.WOOD.ISSUER))
      setIron(getBalance(account, TOKENS.IRON.CODE, TOKENS.IRON.ISSUER))
      setCoal(getBalance(account, TOKENS.COAL.CODE, TOKENS.COAL.ISSUER))
      setSteel(getBalance(account, TOKENS.STEEL.CODE, TOKENS.STEEL.ISSUER))
      setStone(getBalance(account, TOKENS.STONE.CODE, TOKENS.STONE.ISSUER))
      setPickaxes(getBalance(account, TOKENS.PICKAXE.CODE, TOKENS.PICKAXE.ISSUER))
      setSpears(getBalance(account, TOKENS.SPEAR.CODE, TOKENS.SPEAR.ISSUER))
    }
  }, [account])

  function getBalance(account, assetCode, assetIssuer) {
    const assetBalance = account.balances.find(
      balance =>
        balance.asset_code === assetCode && balance.asset_issuer === assetIssuer
    )
    return assetBalance
  }

  async function reloadAccount() {
    try {
      setAccount(await server.loadAccount(publicKey))
    } catch (error) {}
  }

  return {
    setPublicKey,
    account,
    money,
    energy,
    food,
    axes,
    berries,
    meat,
    wood,
    stone,
    steel,
    iron,
    coal,
    axes,
    pickaxes,
    spears,
    hammers,
    reloadAccount,
  }
}
